module.exports = __webpack_public_path__ + "static/media/slide-network.f9a6575b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/slide-network.mp3
// module id = 1378
// module chunks = 1